(function init(arr) {
  arr.forEach(function iterator(item) {
    // eslint-disable-next-line no-prototype-builtins
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        this.parentNode.removeChild(this);
      },
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

(function process() {
  // Note: No assumptions are made to how many headers are on the page (e.g. Demo page has multiple)
  let currentMobileMenu;

  const closeMobileMenu = function closeMobileMenu(event) {
    // if clicked outside menu, then prevent outside link clicks and close menu
    if (currentMobileMenu && !currentMobileMenu.contains(event.target)) {
      currentMobileMenu.classList.add('hidden');
      ['touchstart', 'click'].forEach(function removeEventListener(e) {
        document.querySelector('html').removeEventListener(e, closeMobileMenu);
      });
    }
  };

  // remove mobile menu hamburger if <=1 mobile menu items
  Array.prototype.forEach.call(
    document.getElementsByTagName('header'),
    function headerIterator(elem) {
      const mobileLinks = elem.querySelectorAll(
        '.com-header-mobile-nav a[href]'
      ).length;
      if (mobileLinks <= 1) {
        const desktopLinks = elem.querySelectorAll(
          '.com-header-desktop-nav a[href]'
        ).length;
        if (desktopLinks <= 1) {
          elem
            .querySelector('.com-header-desktop-nav')
            .classList.remove('visible-sm');
          elem.querySelector('.com-header-mobile-nav').remove();
        }
      }

      const mobileBtn =
        elem.querySelector('#com-header-mobile-btn') ||
        elem.querySelector('#com-header-mobile-btn-white');
      if (mobileBtn) {
        mobileBtn.addEventListener('click', function handeClick(event) {
          currentMobileMenu = this.parentNode.querySelector(
            '.com-header-mobile-popup'
          );

          if (currentMobileMenu.classList.contains('hidden')) {
            event.stopPropagation();
            currentMobileMenu.classList.remove('hidden');
            ['touchstart', 'click'].forEach(function addEventListener(e) {
              document
                .querySelector('html')
                .addEventListener(e, closeMobileMenu);
            });
          } else {
            closeMobileMenu(event);
          }
        });
      }
    }
  );
})();

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/node_modules/ui-header/src/header.less');
require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/node_modules/ui-header/src/images/lc-logo-blue.svg');
require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/node_modules/ui-header/src/images/lc-logo-white.png');
require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/node_modules/ui-header/src/images/lc-logo-white.svg');
require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/node_modules/ui-header/src/images/lc-logo.png');